import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Column, Row } from "../../../../../common/columns";
import Line from "../../../../../common/line/Line";
import { ThemeContext } from "../../../../../common/theme/ThemeContext";
import { format } from "date-fns";

function JournalLetters({ letters }) {
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);

  return (
    <>
      {letters.letters.map((letter, index) => (
        <div key={index}>
          <Row>
            <Column>
              <span className={"is-size-6 has-text-weight-bold"}>
                {t("requests.allRequests.journal.letters.registryNumber")}
              </span>
            </Column>
            <Column>
              <span className={"is-size-6 has-text-weight-bold"}>
                {t("requests.allRequests.journal.letters.label")}
              </span>
            </Column>
            <Column>
              <span className={"is-size-6 has-text-weight-bold"}>
                {t("requests.allRequests.journal.letters.submissionDate")}
              </span>
            </Column>
            <Column>
              <span className={"is-size-6 has-text-weight-bold"}>
                {t("requests.allRequests.journal.letters.confirmationDate")}
              </span>
            </Column>
          </Row>

          <Row>
            <Column>{`${letter.registryNumber}`}</Column>
            <Column>{`${letter.label}`}</Column>
            <Column>
              {letter.submissionDate ? format(new Date(letter.submissionDate), "dd.MM.yyyy") : ""}
            </Column>
            <Column>
              {letter.confirmationDate
                ? format(new Date(letter.confirmationDate), "dd.MM.yyyy")
                : ""}
            </Column>
          </Row>
          <Line height={2} color={theme.lineColor} />
          <br />
        </div>
      ))}
    </>
  );
}
export default JournalLetters;
